// extracted by mini-css-extract-plugin
module.exports = {"record":"AcumulateChart_record__3G89K","name":"AcumulateChart_name__2ZoZ5","total":"AcumulateChart_total__2Fu4f"};